import { getRebateValue } from './getRebateValue';
import { MSISRebate } from '../types/marketScan';

/*
 * This function returns the total value of all rebates passed as an argument.
 */
export const getRebatesTotal = (
  rebates: MSISRebate[],
  msrp: number,
): number => {
  const total = rebates.reduce(
    (sum, rebate) => sum + getRebateValue(rebate, msrp),
    0,
  );

  return total;
};
